/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientSurveyModel } from '../../models/client-survey-model';
import { UpdateSurveyRequest } from '../../models/update-survey-request';

export interface UpdateSurvey$Plain$Params {

/**
 * id of survey to update
 */
  surveyId: number;
  
    /**
     * properties to update survey with
     */
    body?: UpdateSurveyRequest
}

export function updateSurvey$Plain(http: HttpClient, rootUrl: string, params: UpdateSurvey$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyModel>> {
  const rb = new RequestBuilder(rootUrl, updateSurvey$Plain.PATH, 'put');
  if (params) {
    rb.path('surveyId', params.surveyId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientSurveyModel>;
    })
  );
}

updateSurvey$Plain.PATH = '/api/Survey/{surveyId}';
